import {
  mallFeDomainApi,
  mallEntranceApi,
  mallEntranceDomainApi
} from '../request'
import { apiPath } from '../api'

export const memberIntegral = {
  getScoreDetail: data => mallFeDomainApi.post(apiPath.getScoreDetail, data),
  memberReceiveCoupon: data =>
    mallFeDomainApi.post(apiPath.memberReceiveCoupon, data),
  scoreExchangeGoods: data =>
    mallFeDomainApi.post(apiPath.scoreExchangeGoods, data),
  getScoreRecord: data => mallFeDomainApi.post(apiPath.getScoreRecord, data),
  queryScoreCouponActivity: data =>
    mallEntranceApi.post(apiPath.queryScoreCouponActivity, data),
  exchangeGoods: data => mallEntranceApi.post(apiPath.exchangeGoods, data),
  queryScoreExchangeGoodsActivity: data =>
    mallEntranceApi.post(apiPath.queryScoreExchangeGoodsActivity, data),
  queryExchangeTrigger: data =>
    mallEntranceApi.post(apiPath.queryExchangeTrigger, data),
  getCompanyInfo: data =>
    mallEntranceDomainApi.post(apiPath.getCompanyInfo, data),
  getScoreExchangeGoodsList: data =>
    mallFeDomainApi.post(apiPath.getScoreExchangeGoodsList, data),
  getScoreActivityTask: data =>
    mallFeDomainApi.post(apiPath.getScoreActivityTask, data),
  receiveIntegralTask: data =>
    mallFeDomainApi.post(apiPath.receiveIntegralTask, data)
}
